import React from "react";
import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "300px"
    }
  }
};

class RelationRequestsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedRequests: [],
      focusedRequest: -1,
      focusedRowIndex: -1
    };

    this.selectRequests = this.selectRequests.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
  }

  selectRequests({ selectedRowsData }) {
    this.setState({ selectedRequests: selectedRowsData });
  }

  onRowClick(e) {
    const focusedRequest = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedRequest, focusedRowIndex });
  }

  render() {
    const {
      selectedRequests,
      focusedRowIndex,
      focusedRequest
    } = this.state;

    const {
      relRequestList,
      classes
    } = this.props;
    const { root } = classes;

    return (
      <div className={root}>
          <DataGrid
            elementAttr={{
              id: "gridContainer"
            }}
            ref={this.dataGridRef}
            wordWrapEnabled={true}
            dataSource={relRequestList}
            onSelectionChanged={this.selectRequests}
            focusedRowEnabled
            errorRowEnabled={false}
            onRowClick={this.onRowClick}
            focusedRowIndex={focusedRowIndex}
            showBorders
          >
            <Selection mode="single" />
            {columns.map(column => (
              <Column key={column.dataField} {...column} />
            ))}
            <FilterRow visible={true} />
            <Scrolling mode="virtual" />
            <LoadPanel enabled/>
          </DataGrid>
      </div>
    );
  }
}

export default withStyles(styles)(RelationRequestsTable);
